<template lang="pug">
div
  .md-headline Feed Configuration
    md-input-container
      label(for='sourceType') Source Type
      md-select#sourceType(name='sourceType', v-model='entity.ingestType', required)
        md-option(value='mrss') MRSS

    transition-group(
      name='fade'
      enter-active-class='animated fadeInDown'
      leave-active-class='animated fadeOutUp'
    )
      md-layout(v-for='(url, index) in entity.urls', :key='`fruit-${index}`')
        md-layout
          md-input-container(:class='{ "md-input-invalid" : (formSubmitted && validations.urls.$each[index].$invalid) || checkUrlError(index) }')
            label Source URL {{ entity.urls.length > 1 ? index + 1 : '' }}
            md-input(v-model='entity.urls[index]')
            span.md-error(v-if='formSubmitted && !validations.urls.$each[index].required') This field is required
            span.md-error(v-if='formSubmitted && !validations.urls.$each[index].url') Invalid URL format
            span.md-error(v-if='checkUrlError(index)') An error has occurred in the last try. Error code: {{ entity.last_run.status_code }}
        md-layout(md-flex='5', md-align='end', v-if='entity.urls.length > 1')
          md-button.md-icon-button.md-warn.md-dense.remove-url(@click='entity.urls.splice(index, 1)')
            md-icon(md-iconset="fa fa-times")
    md-layout(md-align='end')
      md-button.md-icon-button.md-raised.md-dense.md-primary(@click='entity.urls.push("")')
        md-icon(md-iconset="fa fa-plus")
        md-tooltip(md-direction='top') Add URL
</template>

<script>
  export default {
    props: {
      entity: {
        type: Object,
        required: true
      },
      formSubmitted: {
        type: Boolean,
        required: true
      },
      validations: {
        type: Object,
        required: true
      }
    },
    methods: {
      checkUrlError (index) {
        let hasError = this.entity.last_run && (this.entity.last_run.url_index == index &&
          parseInt(this.entity.last_run.status_code) >= 400)
        return hasError
      }
    }
  };
</script>

<style lang="scss" scoped>
  .form-wrapper-frame {
    width: 100%;
    padding: 25px;
    margin-bottom: 15px;
  }
  .remove-url {
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/shared-components/forms/FeedConfigurationForm.vue